import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import CourseDetailView from "../../components/CourseDetailView";
import { publicApi } from "../../admin/adminApi";
export default function CoursePage() {
  const { slug } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setCourse(null);
    async function load() {
      try {
        const data = await publicApi.getCourse(slug);
        if (!cancelled) setCourse(data);
      } catch (err) {
        if (!cancelled) setNotFound(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);
  if (notFound) return <Navigate to="/#courses" replace />;
  if (loading || !course) return <main className="course-page"><div className="container">Loading…</div></main>;
  return <CourseDetailView course={course} />;
}